module.exports = __webpack_public_path__ + "static/media/1m.07281e5f.png";